<script setup>
import { getSearchAPI } from '@/apis/home'
import { watch, ref } from 'vue';
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const router = useRouter()
const currentRoute = ref(router.currentRoute.value.path);
import { useUserStore } from '@/stores/userStore';
const userStore = useUserStore()

// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        console.log('newPath-------', newPath)
        currentRoute.value = newPath;
    }
);
const content = ref('')

const fullscreenLoading = ref(false)
const goCategory = async () => {

    fullscreenLoading.value = true
    console.log(objectString.value)
    try {
    const res = await getSearchAPI({ keyword: content.value })
    if (res.code == 0) {

    fullscreenLoading.value = false
        results.value = res.data.data

        if (res.data.third_party_data.from) {
            // 将对象转换为JSON字符串
            objectString.value = JSON.stringify(res.data.third_party_data);
            localStorage.setItem('thirdData', objectString.value)

        }
        if (res.data.third_party_data.from) {
            router.push({ path: '/externals/' + res.data.third_party_data.from + '/' + res.data.third_party_data.product_id })

        } else {
            router.push({ path: '/category/sub/2/' + content.value })
            localStorage.setItem('thirdData', '')
        }

    } else {
        fullscreenLoading.value = false

        ElMessage({ type: 'error', message: res.message })
    }
    } catch (error) {
        fullscreenLoading.value = false
    }
   



}
console.log(content.value)

const formData = reactive({

    userform: {
        avatar: null,
    }

})
const handleKeyDown = (event) => {
    if (event.keyCode === 13) { // 回车键的 keyCode 是 13
        goCategory()
        // 你的逻辑代码
        // console.log('回车键被按下');
        // event.preventDefault(); // 阻止默认行为，如表单提交
    }
}
onMounted(() => {
    formData.userform = userStore.userInfo
});
const objectString = ref()
const results = ref([])
const onSearch = async (content) => {
    console.log(content)
    // 模拟搜索结果
    if (content == '' || content == undefined) {
        results.value = [];
    } else {
        console.log(content)

        const res = await getSearchAPI({ keyword: content })
        if (res.code == 0) {
            results.value = res.data.data

            if (res.data.third_party_data.from) {
                // 将对象转换为JSON字符串
                objectString.value = JSON.stringify(res.data.third_party_data);
                localStorage.setItem('thirdData', objectString.value)
            }

        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    }
}
const setCategory = (zhi) => {
    content.value = zhi
    router.push({ path: '/category/sub/2/' + content.value })
}
</script>

<template>
    <header class='app-header' v-if="currentRoute == '/category'">
        <div class="container" v-if="currentRoute == '/category'" v-loading.fullscreen.lock="fullscreenLoading">

            <div class="search">
                <div class="search-container search-category">
                    <div style="display: flex;  margin-right: 2px;">

                        <div class="icon" @click="content = ''">
                            <svg-icon icon-class="search" style="width: 14px;height: 14px;" />
                        </div>
                    </div>
                    <input type="text" class="search-input" :placeholder="t('setup28')" @input="onSearch(content)"
                        v-model="content" @keydown="handleKeyDown" clearable />
                    <div style="display: flex;margin-left: -90px;    margin-right: 13px;" v-if="content == ''">
                        <div class="icon">
                            <svg-icon icon-class="taobao" style="width: 18px;height: 18px;" />
                        </div>
                        <div class="icon">
                            <svg-icon icon-class="1688" style="width: 18px;height: 18px;" />
                        </div>
                        <div class="icon">
                            <svg-icon icon-class="dian" style="width: 18px;height: 18px;" />
                        </div>
                    </div>
                    <div style="display: flex;margin-left: -90px;    margin-right: 13px;" v-if="content !== ''">

                        <div class="icon" @click="content = ''">
                            <svg-icon icon-class="close" style="width: 18px;height: 18px;" />
                        </div>
                    </div>
                    <!-- <i class="iconfont icon-search" @click="goCategory()"></i>-->
                    <!-- <el-button type="success" @click="goCategory()" size="small" round>Search</el-button> -->
                </div>
                <div class="resule" v-if="results && results.length > 0">
                    <ul v-if="results.length">
                        <li v-for="(result, index) in results" :key="index" @click="setCategory(result.text)">{{
                            result.text
                            }}</li>
                    </ul>
                </div>
            </div>

        </div>
    </header>
</template>


<style scoped lang='scss'>
.container {
    width: 100%;
}

.app-header {
    height: 58px;
    padding: 4px 5px;
    z-index: 999;
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
    // background: #413e3e;`
    width: 100%;

    .container {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .logo {
        // width: 50px;
        width: 46px;
        margin-right: 5px;

        a {
            background: linear-gradient(to right, #56a9ff, #f56c6c, );
            -webkit-background-clip: text;
            color: transparent;
            font-size: 12px;
            // padding-left: 16px;
            font-weight: 700;
        }
    }


    .search {
        width: 100%;
        // height: 30px;
        // padding: 0 8px;
        // border: 1px solid #eee;
        // background-color: #f8f8f8;
        // border-radius: 25px;
        // width: 170px;
        position: relative;
        line-height: 32px;
        display: flex;
        align-items: center;

        .search-container {
            display: flex;
            align-items: center;
            background-color: #ffffff;
            padding: 2px 2px 2px 10px;
            border-radius: 60px;
            width: 100%;
            border: 1px solid #eee;
        }

        .search-input {
            border: none;
            outline: none;
            padding: 0px;
            border-radius: 20px;
            flex-grow: 1;
            margin-right: 5px;
        }

        .search-category {
            padding: 2px;
            background-color: #f1f1f1;
            height: 30px;
            overflow: hidden;

            >input {
                background-color: #f1f1f1;
            }
        }

        .search-button {
            background-color: #ff4d4f;
            color: white;
            border: none;
            padding: 10px 10px;
            border-radius: 20px;
            cursor: pointer;
        }

        .search-button:hover {
            background-color: #e03e3e;
        }

        .icon {
            margin-left: 4px;
            width: 18px;
            height: 18px;
            // background-color: #ddd;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        // .icon-search {
        //     font-size: 12px;
        //     margin-left: 0px;
        //     margin-right: 10px;
        // }

        // input {
        //     font-size: 12px;
        //     width: 130px;
        //     padding-left: 5px;
        //     color: #666;
        //     padding: 0;
        //     height: 22px;
        //     border: 0;
        //     background-color: transparent;
        //     outline: 0;
        //     box-shadow: none !important;
        // }
        .resule {
            border-radius: 10px;
            position: fixed;
            top: 45px;
            background-color: #ffffffed;
            z-index: 99999;
            width: 95%;
            height: 100px;
            font-size: 13px;
            overflow: auto;

            ul {
                li {
                    padding: 0 10px;

                    &:hover {

                        background-color: #f4f4f8;
                    }
                }
            }
        }
    }

    .cart {
        // width: 50px;
        width: 32px;
        font-size: 12px;
        margin-left: 5px;

        .avatar .loginBut {
            height: 27px;
        }

        .svg-icon {
            width: 19px !important;
            height: 19px !important;
            margin-right: 8px !important;
        }

        .curr {
            height: 32px;
            line-height: 32px;
            text-align: center;
            position: relative;
            display: block;

            .icon-cart {
                font-size: 22px;
            }

            em {
                font-style: normal;
                position: absolute;
                right: 0;
                top: 0;
                padding: 1px 6px;
                line-height: 1;
                background: $helpColor;
                color: #fff;
                font-size: 12px;
                border-radius: 10px;
                font-family: Arial;
            }

            .svg-icon {
                margin-right: 9px;
            }
        }
    }

    .tab {
        display: flex;
        align-items: center;


    }

}

.app-header-nav {
    width: 820px;
    display: flex;
    padding-left: 40px;
    position: relative;
    z-index: 998;

    li {
        margin-right: 40px;
        width: 38px;
        text-align: center;

        a {
            font-size: 16px;
            line-height: 32px;
            height: 32px;
            display: inline-block;

            &:hover {
                color: $xtxColor;
                border-bottom: 1px solid $xtxColor;
            }
        }

        .active {
            color: $xtxColor;
            border-bottom: 1px solid $xtxColor;
        }
    }
}

.el-button--small.is-round {
    padding: 15px 10px;
    border-radius: 19px;
}
</style>